import React from 'react'

let Agrumi = () =>
    <article>
        <h1>Agrumi</h1>
    </article>

export let Oidio = () =>
    <article>
        <h1>Oidio</h1>
        <p>L’Oidio è una malattia degli agrumi generata da un fungo e si manifesta sulle foglie e sui frutti con la caratteristica muffa bianca, sotto la quale sono presenti necrosi reticolate bruno nerastro <i>(Ascomycota)</i> che si sviluppa soprattutto in presenza di condizioni climatiche umide, mediamente calde e in caso di scarsa aerazione.</p>
        <p>L’oidio di presenta sulla pianta in due forme che possono coesistere:</p>
        <ul>
            <li>forma ascofora <i>(Uncinula necator)</i>, con spore racchiuse in organi detti cleistoteci, i quali si aprono con piogge di almeno 2,5 mm e temperatura superiore ai 10° C.</li>
            <li>forma conidica <i>(Oidium tuckeri)</i> con sviluppo anche a temperature basse (a partire dai 5° fino ai 30/35° C, ottimale a 27° C) e in presenza di scarsa umidità relativa (inferiore al 50%).</li>
        </ul>
        <p>In entrambe le forme, lo oidio può svernare sull’agrume e manifestarsi dall’inizio della primavera fino all’estate.</p>
        
        <p>Elementi di monitoraggio per la forma <b>Ascofora</b>:</p>
        <ul>
            <li>temperatura media &gt; 10 °C;</li>
            <li>piovosità (ultimi giorni) di almeno 2.5 mm di acqua;</li>
        </ul>
        <p>Elementi di monitoraggio per la forma <b>Conidica</b>:</p>
        <ul>
            <li>temperatura media tra i 10 °C e 35 °C;</li>
            <li>umidità relativa (inferiore al 50%).</li>
        </ul>

        <p>Il micelio sopravvive nelle gemme che, a primavera, si dischiudono in germogli completamente ricoperti di muffa bianca. Il fungo sporula e, attraverso i conidi, infetta le parti verdi della pianta. I cleistoteci, in cui sono racchiuse le ascospore del fungo, si formano su foglie e germogli nella tarda estate. Svernano e restano chiusi fino a primavera. Con la loro apertura, si infettano i tessuti verdi della pianta su cui il fungo continua a sporulare.</p>
        <p>In entrambi i casi, i conidi prodotti sono dispersi dal vento, causando infezioni secondarie.</p>

        <h2>Sintomi</h2>
        <ul>
            <li>attacca le foglie, le infiorescenze e i rami ancora verdi, ricoprendoli di un pulviscolo bianco-grigiastro a contorno indefinito;</li>
            <li>i rami malati lignificano incompletamente e sono facilmente uccisi dai freddi invernali;</li>
            <li>le foglie si deformano e funzionano in modo irregolare;</li>
        </ul>
        <figure>
            <img src={require('img/pictures/agrumi-oidio-1.jpg')} alt="" />
            <img src={require('img/pictures/agrumi-oidio-2.jpg')} alt="" />
            <figcaption>Sintomi di Oidio degli agrumi.</figcaption>
        </figure>

        <h2>Difesa</h2>
        <ul>
            <li>deve essere combattuto a livello preventivo, mai a livello curativo;</li>
            <li>bisogna intervenire fra ripresa vegetativa e inizio fioritura, se necessario (es. copertura con reti antigrandine).</li>
        </ul>

    </article>

export default Agrumi